export default class PaymentRequestStatusChangeItem {
  constructor(item) {
    this.initialize(item);
  }

  initialize(item) {
    this.IeId = item.ieId;
    this.Action = '';
    this.Comment = '';
  }
}
